<template>
  <div
    class="modal fade"
    id="infoModal"
    tabindex="-1"
    aria-labelledby="infoModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="infoModalLabel">
            I. Información de parámetros
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <p class="text-white pt-3 modalIcon">I</p>
                <p>Capacidad de pago</p>
                <p>Capacidad de pago FLEX</p>
                <p>Capacidad de endeudamiento</p>
                <p>Capacidad de endeudamiento FLEX</p>
                <p>Loan to value actual</p>
                <p>Score de buró de crédito</p>
                <p>Probabilidad de pago BC</p>
              </div>
              <div class="col">
                <div class="row text-center bg-light">
                  <div class="col">
                    <p class="pt-3">
                      <i class="bi bi-record-circle modalIcon amarillo"></i>
                    </p>
                    <p>&lt; 28.5%</p>
                    <p>&lt; 34%</p>
                    <p>&lt; 40%</p>
                    <p>&lt; 44%</p>
                    <p>&lt; 65%</p>
                    <p>&gt; 695</p>
                    <p>&gt; 75%</p>
                  </div>
                  <div class="col modalColum">
                    <p class="pt-3">
                      <i class="bi bi-record-circle modalIcon naranja"></i>
                    </p>
                    <p>28.6%- 33.5%</p>
                    <p>34.1%- 39%</p>
                    <p>40.1% - 45%</p>
                    <p>44.1% - 49%</p>
                    <p>65.1% - 69%</p>
                    <p>580 - 695</p>
                    <p>55% - 75%</p>
                  </div>
                  <div class="col bg-light">
                    <p class="pt-3">
                      <i class="bi bi-record-circle modalIcon rojo"></i>
                    </p>
                    <p>&gt; 33.5%</p>
                    <p>&gt; 39%</p>
                    <p>&gt; 45%</p>
                    <p>&gt; 49%</p>
                    <p>&gt; 69%</p>
                    <p>&lt; 580</p>
                    <p>&lt; 55%</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal B -->
  <div
    class="modal fade"
    id="infoModalB"
    tabindex="-1"
    aria-labelledby="infoModalBLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="infoModalBLabel">
            II. Información de parámetros
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row justify-content-md-center">
              <div class="col-md-4">
                <p class="text-white pt-3 modalIcon">I</p>
                <p>Score Interno (pts)</p>
                <p>Rating Score Interno</p>
                <p>Riesgo Estimado Política de Crédito</p>
                <p>Estrategia Recomendada Política de Crédito</p>
              </div>
              <div class="col-md-8">
                <div class="row text-center justify-content-md-center">
                  <div class="col bg-light">
                    <p class="pt-2">
                      <i class="bi bi-record-circle modalIcon verde"></i>
                    </p>
                    <p>676-800</p>
                    <p>AAA</p>
                    <p>0% - 4.0%</p>
                    <p>Proceso Ágil</p>
                  </div>
                  <div class="col modalColum">
                    <p class="pt-2">
                      <i class="bi bi-record-circle modalIcon amarillo"></i>
                    </p>
                    <p>551-675</p>
                    <p>AA</p>
                    <p>4.1% - 6.0%</p>
                    <p>Domiciliar</p>
                  </div>
                  <div class="col bg-light">
                    <p class="pt-2">
                      <i class="bi bi-record-circle modalIcon naranja"></i>
                    </p>
                    <p>426-550</p>
                    <p>A</p>
                    <p>6.1% - 10%</p>
                    <p>Domiciliar|Obligado Solidario</p>
                  </div>
                  <div class="col modalColum">
                    <p class="pt-2">
                      <i class="bi bi-record-circle modalIcon rojo"></i>
                    </p>
                    <p>300-425</p>
                    <p>BBB</p>
                    <p>>10%</p>
                    <p>Domiciliar|Cotitular</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-5">
                <p>Contratos Domiciliados</p>
              </div>
              <div class="col-md-7 text-center justify-content-md-center">
                <p>
                  <i class="bi bi-x-lg rojo"></i> No todos domiciliados
                  <i class="bi bi-check-lg verde"></i>
                  Todos domiciliados
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "ModalParametros",
});
</script>

<style scoped>
.modalColum {
  background-color: #eceff2;
}

.modalIcon {
  font-size: 30px;
}
</style>
